import { useState } from 'react';

import { useFilterContext } from '../../../../contexts/FiltersContext';
import { useListingsContext } from '../../../../contexts/ListingsContext';
import { useListingsQuery } from '../../../../types/api.graphql';

const DEFAULT_PAGE_SIZE = 40;

export const useListingsFiltersQueryVariables = () => {
  const { searchQueryVariable, getSelectedFilters, getSortValue } = useFilterContext();

  /**
   * Returns the variables for the listings query.
   * One use for this is to update the cache of the listings,
   * because query to the cache needs to be the exact same as
   * the original query.
   */
  const getFiltersQueryVariables = () => {
    return {
      first: DEFAULT_PAGE_SIZE,
      query: searchQueryVariable,
      filters: getSelectedFilters(),
      sort: getSortValue() ?? [],
    };
  };

  return {
    getFiltersQueryVariables,
  };
};

export const useListings = () => {
  const { setNewListingsDataAvailable } = useListingsContext();

  // Dependencies
  const { searchQueryVariable, getSelectedFilters, getSortValue } = useFilterContext();

  const [refetching, setRefetching] = useState(false);

  const {
    data,
    loading: loadingQuery,
    fetchMore,
    refetch,
  } = useListingsQuery({
    variables: {
      first: DEFAULT_PAGE_SIZE,
      query: searchQueryVariable,
      filters: getSelectedFilters(),
      sort: getSortValue() ?? [],
    },
  });

  const reload = async () => {
    setRefetching(true);
    await refetch();
    setRefetching(false);
    setNewListingsDataAvailable(false);
  };

  return {
    data,
    loading: loadingQuery || refetching,
    refetching,
    fetchMore,
    refetch,
    reload,
  };
};
